import { IonInput, IonItem, IonLabel } from "@ionic/react"
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormFirstName: React.FC<Props> = (props) => {
  return (
    <IonItem>
      <IonLabel position="floating">Vorname</IonLabel>
      <IonInput value={props.value} onIonChange={e => props.onChange((e.target as HTMLInputElement).value)} />
    </IonItem>
  )
}

export default FormFirstName
